/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import qs from 'qs';
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  Grid,
  Icon,
  Label,
  List,
  Loader,
  Menu,
  Message,
  Popup,
  Segment,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import clone from 'clone';
import moment from 'moment-timezone';
import 'moment/locale/vi';
import 'moment/locale/id';
import { required, numericRange } from '@mhub/web-validations';
import config from '../../../config';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import AppForm from '../../components/AppForm';
import TextArea from '../../components/AppForm/TextArea';
import NavBar from '../../components/NavBar';
import AddressSettingList from '../../components/AddressSettingList';
import AddressSettingActivities from '../../components/AddressSettingActivities';
import DelistReasonsList from '../../components/DelistReasonsList';
import { setItem } from '../../utils/storage';
import { fetchCurrencySetting } from '../../actions/currencySetting';
import { isForeignCompany } from '../../utils/companies';
import { AWSUrl } from '../../utils/url';
import CustomField from '../../components/CustomField';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import FinanceSourceList from '../../components/FinanceSourceList';
import { BookingSelectList, BookingSearchList } from '../../components/Filters';
import { fetchAppConfig } from '../../actions/appConfig';
import { isVietnamCompany } from '../../utils/vietnam';
import { displayMoment } from '../../utils/displayTime';

const isPRS = config.get('prs');

class SystemSettings extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        companyID: PropTypes.int,
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    auth: PropTypes.shape({
      company: PropTypes.object,
      isAdmin: PropTypes.bool,
      isAdminCommunity: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static defaultTempData = {
    userRoleManagePayment: ['hq'],
  }
  static defaultData = {
    // access by role
    canManagePaymentSupervisor: false,
    canManagePaymentSalesManager: false,
    canManagePaymentSalesAdmin: false,

    // access by function
    allowStaffEditBookingStatus: true,
    allowStaffEditBookingStatusCancel: true,

    // features
    allowUnitSocialShare: true,
    disableSoldDateEditing: false,
    disableSoldDateSelection: false,
    disableCancelledDateEditing: false,

    // auto-release
    arBookingExpUnpaidIsEnabled: false,
    arBookingExpNricPicIsEnabled: false,
    arBookingExpAllNricPicsIsEnabled: false,
    arBookingExpMortgageEnabled: false,
    arBookingExpMoreThanMinutes: '0',

    // auto-release for aging bookings
    arAgingBookingExpReservedIsEnabled: false,
    arAgingBookingExpBookedIsEnabled: false,
    arAgingBookingExpMoreThanMinutes: '0',

    // cooldown
    unitCooldownIsEnabled: false,
    unitCooldownTimeMinutes: 0,

    // project
    regions: [],
    townships: [],
    agencyAllocationAllocateAll: true,

    // address
    addressFormatTemplate: '',

    // unit custom field settings
    projectUnitCustomFieldSettings: [],

    // currency settings
    currencySetting: {
      isAbbreviationEnabled: false,
      abbreviationDecimalPoints: 2,
    },

    // sms templates
    leadDropSMSTemplate: 'default',
    leadSuccessSMSTemplate: 'default',

    // notes settings
    notesExternalPlaceholder: '',

    // data formatting
    uppercasePurchaserInfoIsEnabled: false,

    // docx templater setting
    docxTemplaterIsEnabled: false,

    // docx templater debugging setting
    docxTemplaterDebuggingIsEnabled: false,

    // print form visibility
    allowAllBusinessUnitViewNewForm: false,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const loadingMessage = `${props.t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    const noResultsMessage = loadingMessage;
    return {
      topMenuIsTab: windowWidth <= 590,
      menuIsTab: windowWidth >= 991,
      menuIsVertical: windowWidth >= 991,
      noResultsMessage,
    };
  }
  constructor(props) {
    super(props);
    const state = SystemSettings.getPropsToState(props);
    if (this.hasAdminAccess(props)) {
      this.tabs.push({
        name: 'cache',
        value: 'cache',
        text: 'Cache (Admin)',
        fields: [],
      });
    }
    if (!isPRS) {
      this.tabs.push({
        name: 'auto_release',
        value: 'auto_release',
        text: 'Auto-Release Settings',
        fields: [],
      });
    }
    if (this.props.auth.isAdminBasic) {
      this.tabs.splice(1, 0, {
        name: 'sms',
        value: 'sms',
        text: 'SMS Templates',
        fields: [],
      });
    }
    this.state = {
      ...state,
      currentTab: this.tabs[0].name,
      data: clone(SystemSettings.defaultData),
      oriData: clone(SystemSettings.defaultData),
      tempData: clone(SystemSettings.defaultTempData),
      errMessages: [],
      loading: true,
      token: null,
      applyArToAllProjects: false,
      applyAgingArToAllProjects: false,
      regionOptions: [],
      townshipOptions: [],
      cooldownOptions: [...this.cooldownOptions],
      cacheOptions: [...this.cacheOptions],
      previewFormat: '',
      addressSettings: [],
      oriAddressSettings: [],
      financeSources: [],
      oriFinanceSources: [],
      activitiesLoading: true,
      addressSettingActivities: [],
      currencySettingLoading: false,
      unitCustomSettingsLoading: false,
      unitCustomFieldSettings: [],
      oriUnitCustomFieldSettings: [],
      packagePricingList: [],
      projectPackagePricingID: '',
      findProjectResults: [],
      loadingProjectSearch: false,
      projectKeyword: '',
      projectID: '',
      smsTemplates: [],
      reservationTokenSettings: { priceMinor: 0, validityDurationDays: 0, limitPerOpportunity: 0, currencyCode: 'MYR' },
      oriReservationTokenSettings: { priceMinor: 0, validityDurationDays: 0, limitPerOpportunity: 0, currencyCode: 'MYR' },
      reservationTokenLoading: false,
    };
    this.validation = {
      canManagePaymentOptions: createRef(),
      arBookingExpMoreThanMinutes: createRef(),
      arAgingBookingExpMoreThanMinutes: createRef(),
      addressFormatTemplate: createRef(),
    };
  }
  componentDidMount() {
    this.fetchSystemSettings();
    this.fetchAddressSettingActivities();
    this.fetchUnitCustomFieldSettings();
    this.fetchSMSTemplates();
    if (this.canAccessReservationTokenSettings()) {
      this.fetchReservationTokenSettings();
    }
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = SystemSettings.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  setLoadingProjectSearch(loadingProjectSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingProjectSearch }, res);
    });
  }
  setActivitiesLoading(activitiesLoading = false) {
    return new Promise((res) => {
      this.setState({ activitiesLoading }, () => {
        res(activitiesLoading);
      });
    });
  }
  setCurrencySettingLoading(currencySettingLoading = false) {
    return new Promise((res) => {
      this.setState({ currencySettingLoading }, () => {
        res(currencySettingLoading);
      });
    });
  }
  setUnitCustomSettingsLoading(unitCustomSettingsLoading = false) {
    return new Promise((res) => {
      this.setState({ unitCustomSettingsLoading }, () => {
        res(unitCustomSettingsLoading);
      });
    });
  }
  getReleaseRequirementSettings = (data) => {
    if (data) {
      if (data.arBookingExpUnpaidIsEnabled || data.arBookingExpNricPicIsEnabled || data.arBookingExpAllNricPicsIsEnabled || data.arBookingExpMortgageEnabled || (data.arBookingExpMoreThanMinutes && data.arBookingExpMoreThanMinutes !== '' && data.arBookingExpMoreThanMinutes !== '0')) {
        this.setState({ applyArToAllProjects: true });
        return true;
      }
    }
    return false;
  }
  getAgingReleaseRequirementSettings = (data) => {
    if (data) {
      if (data.arAgingBookingExpReservedIsEnabled || data.arAgingBookingExpBookedIsEnabled || (data.arAgingBookingExpMoreThanMinutes !== '' && data.arAgingBookingExpMoreThanMinutes !== '0')) {
        this.setState({ applyAgingArToAllProjects: true });
        return true;
      }
    }
    return false;
  }
  async fetchSMSTemplates() {
    await this.setLoading(true);
    const { store } = this.context;
    const { auth, t } = this.props;
    if (auth.isAdminBasic) {
      let res;
      try {
        res = await store.dispatch(fetchM('/sms_templates/', {
          credentials: 'include',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
        await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
        await this.setLoading(false);
        return;
      }
      if (!res.ok) {
        const message = await res.text();
        await store.dispatch(flashErrorMessage({ message }));
      } else {
        const data = await res.json();
        const token = res.headers.get('X-Csrf-Token');
        const templates = data ? data.map(x => ({
          value: x.id,
          text: x.name,
        })) : [];
        // handle token.. etc
        await this.setComponentState({
          token,
          smsTemplates: templates,
        });
      }
    }
    await this.setLoading(false);
  }
  async fetchSystemSettings() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      const token = res.headers.get('X-Csrf-Token');
      // handle token.. etc
      data.agencyAllocationAllocateAll = Boolean(data.agencyAllocationAllocateAll);
      if (data && data.arBookingExpMoreThanMinutes && data.arBookingExpMoreThanMinutes !== '' && data.arBookingExpMoreThanMinutes !== '0') {
        const fltHours = Number(data.arBookingExpMoreThanMinutes) / 60;
        data.arBookingExpMoreThanMinutes = Math.round(fltHours * 10) / 10;
      }
      if (data && data.arAgingBookingExpMoreThanMinutes && data.arAgingBookingExpMoreThanMinutes !== '' && data.arAgingBookingExpMoreThanMinutes !== '0') {
        const fltHours = Number(data.arAgingBookingExpMoreThanMinutes) / 60;
        data.arAgingBookingExpMoreThanMinutes = Math.round(fltHours * 10) / 10;
      }
      const regions = data.regions ? data.regions : [];
      const { regionOptions } = this.state;
      regions.forEach(i => regionOptions.push({
        value: i,
        text: i,
      }));
      const townships = data.townships ? data.townships : [];
      const { townshipOptions } = this.state;
      townships.forEach(i => townshipOptions.push({
        value: i,
        text: i,
      }));
      let { cooldownOptions, cacheOptions } = this.state;
      if (data.unitCooldownTimeMinutes) {
        data.unitCooldownTimeMinutes = data.unitCooldownTimeMinutes.toString();
        const cdOptionExists = this.state.cooldownOptions.findIndex(co => co.value === data.unitCooldownTimeMinutes);
        if (cdOptionExists === -1) {
          cooldownOptions = [
            { key: data.unitCooldownTimeMinutes, text: data.unitCooldownTimeMinutes, value: data.unitCooldownTimeMinutes },
            ...this.state.cooldownOptions,
          ];
        }
      }
      if (data.salesChartCacheMinutes) {
        data.salesChartCacheMinutes = data.salesChartCacheMinutes.toString();
        const cdOptionExists = this.state.cacheOptions.findIndex(co => co.value === data.salesChartCacheMinutes);
        if (cdOptionExists === -1) {
          cacheOptions = [
            { key: data.salesChartCacheMinutes, text: data.salesChartCacheMinutes, value: data.salesChartCacheMinutes },
            ...this.state.cacheOptions,
          ];
        }
      }
      if (data.leadDropSMSTemplate === '') {
        data.leadDropSMSTemplate = 'default';
      }
      if (data.leadSuccessSMSTemplate === '') {
        data.leadSuccessSMSTemplate = 'default';
      }
      if (data.notesExternalPlaceholder === '') {
        data.notesExternalPlaceholder = t('Type a note...', { ns: TRANSLATION_FILES.translation });
      }
      await this.setComponentState({
        token,
        data,
        regionOptions,
        townshipOptions,
        cooldownOptions,
        cacheOptions,
        oriData: clone(data),
        tempData: this.prepareTempData(data),
        applyArToAllProjects: this.getReleaseRequirementSettings(data),
        applyAgingArToAllProjects: this.getAgingReleaseRequirementSettings(data),
      });
      setItem(`${config.get('appName')}.globalSettings`, JSON.stringify({
        data,
        createdAt: moment().toDate(),
        version: config.get('version'),
      }));
      if (data && data.company && isForeignCompany(data.company)) {
        await this.fetchCurrencySetting(data.company.id, data);
      }
    }
    await this.setLoading(false);
  }
  async updateSystemSettings(validations, data, addressSettings) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const stateData = {
      ...data,
      addressSettings,
    };
    const { applyArToAllProjects, applyAgingArToAllProjects, unitCustomFieldSettings, financeSources } = this.state;
    const noTimer = (stateData.arBookingExpMoreThanMinutes && (Number(stateData.arBookingExpMoreThanMinutes) < 1 || stateData.arBookingExpMoreThanMinutes === '')) || !stateData.arBookingExpMoreThanMinutes;
    // CPI-974 (D20): Vietnam never sees the Auto-Release criteria grid, so the same gate has to
    // cover this validation or a Vietnamese company can never save.
    if (!isVietnamCompany(this.props.auth) && applyArToAllProjects && (
      // no timer no requirements
      (noTimer && !stateData.arBookingExpNricPicIsEnabled && !stateData.arBookingExpAllNricPicsIsEnabled && !stateData.arBookingExpUnpaidIsEnabled && !stateData.arBookingExpMortgageEnabled) ||
      // got timer no requirements
      (!noTimer && !stateData.arBookingExpNricPicIsEnabled && !stateData.arBookingExpAllNricPicsIsEnabled && !stateData.arBookingExpUnpaidIsEnabled && !stateData.arBookingExpMortgageEnabled) ||
      // no timer got requirements
      (noTimer && (stateData.arBookingExpNricPicIsEnabled || stateData.arBookingExpAllNricPicsIsEnabled || stateData.arBookingExpUnpaidIsEnabled || stateData.arBookingExpMortgageEnabled))
    )) {
      store.dispatch(flashErrorMessage({
        message: `${t('Please make sure to set Auto release timer and keep at least one Auto-Release Requirement "On" if you\'d like auto-release feature to be enabled', { ns: TRANSLATION_FILES.translation })}.`,
      }));
      this.setLoading(false);
      return;
    }

    const noAgingTimer = (stateData.arAgingBookingExpMoreThanMinutes && (Number(stateData.arAgingBookingExpMoreThanMinutes) < 1 || stateData.arAgingBookingExpMoreThanMinutes === '')) || !stateData.arAgingBookingExpMoreThanMinutes;
    if (applyAgingArToAllProjects && (
      // no timer no requirements
      (noAgingTimer && !stateData.arAgingBookingExpReservedIsEnabled && !stateData.arAgingBookingExpBookedIsEnabled) ||
      // got timer no requirements
      (!noAgingTimer && !stateData.arAgingBookingExpReservedIsEnabled && !stateData.arAgingBookingExpBookedIsEnabled) ||
      // no timer got requirements
      (noAgingTimer && (stateData.arAgingBookingExpReservedIsEnabled || stateData.arAgingBookingExpBookedIsEnabled))
    )) {
      store.dispatch(flashErrorMessage({
        message: `${('Please make sure to set Time limit timer and keep at least one Time Limit Booking Status "On" if you\'d like auto-release time limit feature to be enabled')}.`,
      }));
      this.setLoading(false);
      return;
    }


    // currency setting
    if (stateData.currencySetting) {
      stateData.currencySetting.abbreviationDecimalPoints = Number(stateData.currencySetting.abbreviationDecimalPoints);
      if (stateData.currencySetting.abbreviationDecimalPoints < 0) {
        store.dispatch(flashErrorMessage({ message: t('Abbreviation decimal points must be more or equals to 0', { ns: TRANSLATION_FILES.translation }) }));
        this.setLoading(false);
        return;
      }
      if (stateData.currencySetting.abbreviationDecimalPoints % 1 !== 0) {
        store.dispatch(flashErrorMessage({ message: t('Abbreviation decimal points should not contains decimal points', { ns: TRANSLATION_FILES.translation }) }));
        this.setLoading(false);
        return;
      }
    }

    // set unit custom fields multi_dropdown default value
    const ucfs = [...unitCustomFieldSettings];
    if (ucfs && ucfs.length > 0) {
      const hasMultiDropdown = ucfs.findIndex(ucf => ucf.type === 'dropdown_multi');
      if (hasMultiDropdown !== -1) {
        let i = 0;
        while (i < ucfs.length) {
          if (ucfs[i].type === 'dropdown_multi') {
            let defaultValue = '';
            if (_.isArray(ucfs[i].defaultValue)) {
              defaultValue = ucfs[i].defaultValue.filter(v => v !== '').join(',');
            }
            ucfs[i].defaultValue = defaultValue;
          }
          i += 1;
        }
      }
    }
    stateData.projectUnitCustomFieldSettings = ucfs;

    // Finance sources
    let newFinanceSources = financeSources ? [...financeSources] : [];

    const emptyFinanceLabel = newFinanceSources.findIndex(s => !s.label);
    if (emptyFinanceLabel > -1) {
      store.dispatch(flashErrorMessage({ message: 'Sources of Financing\'s Label is required' }));
      this.setLoading(false);
      return;
    }

    if (!newFinanceSources.some(s => s.isEnabled)) {
      store.dispatch(flashErrorMessage({ message: 'Source of Financing must have at least 1 enabled source' }));
      this.setLoading(false);
      return;
    }

    if (newFinanceSources.length > 0) {
      newFinanceSources = newFinanceSources.map((fs) => {
        const newFs = { ...fs };
        if (!isNaN(fs.id)) {
          newFs.id = '';
        }
        return newFs;
      });
    }

    stateData.financeSources = newFinanceSources;

    const errors = validations.filter(v => !v.isValid);

    const addressSettingValidations = await this.addressSettingList.validate();
    const financeSourcesValidations = await this.financeSourceList.validate();
    errors.concat([...addressSettingValidations, ...financeSourcesValidations].filter(v => !v.isValid));

    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      this.setLoading(false);
      return;
    }
    if (!noTimer) {
      stateData.arBookingExpMoreThanMinutes = (Math.round(Number(stateData.arBookingExpMoreThanMinutes) * 60)).toString();
    }
    if (!noAgingTimer) {
      stateData.arAgingBookingExpMoreThanMinutes = (Math.round(Number(stateData.arAgingBookingExpMoreThanMinutes) * 60)).toString();
    }
    if (!noTimer && !noAgingTimer && Math.round(Number(stateData.arBookingExpMoreThanMinutes) * 60) > Math.round(Number(stateData.arAgingBookingExpMoreThanMinutes) * 60)) {
      store.dispatch(flashErrorMessage({ message: 'Auto release timer must be less or equals to Time limit timer' }));
      this.setLoading(false);
      return;
    }
    if (stateData.unitCooldownTimeMinutes) {
      stateData.unitCooldownTimeMinutes = parseInt(stateData.unitCooldownTimeMinutes, 10);
    }
    if (stateData.salesChartCacheMinutes) {
      stateData.salesChartCacheMinutes = parseInt(stateData.salesChartCacheMinutes, 10);
    }
    if (stateData.leadDropSMSTemplate === 'default') {
      stateData.leadDropSMSTemplate = '';
    }
    if (stateData.leadSuccessSMSTemplate === 'default') {
      stateData.leadSuccessSMSTemplate = '';
    }
    if (stateData.notesExternalPlaceholder === 'Type a note...') {
      stateData.notesExternalPlaceholder = '';
    }
    try {
      await store.dispatch(fetchM('/settings/', {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(stateData),
      }));
    } catch (err) {
      await this.setLoading(false);
      this.financeSourceList.fetchFinanceSources();
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setComponentState({
      isEditing: false,
    });
    await this.setLoading(false);
    this.fetchSystemSettings();
    this.addressSettingList.fetchAddressSettings();
    this.financeSourceList.fetchFinanceSources();
    this.fetchAddressSettingActivities();
    this.fetchUnitCustomFieldSettings();
    store.dispatch(fetchAppConfig());
    if (isForeignCompany(stateData.company)) {
      store.dispatch(fetchCurrencySetting());
    }
    store.dispatch(flashSuccessMessage({
      header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
      message: `${t('System settings successfully updated', { ns: TRANSLATION_FILES.translation })}.`,
    }));
  }
  async bulkRecalculateUnitPackagePricing() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/recalculate_unit_package_pricing/', {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Pricing package successfully updated in all units', { ns: TRANSLATION_FILES.translation }) }));
    }
    await this.setLoading(false);
  }
  async searchProjects(value) {
    const { store } = this.context;
    const { t } = this.props;
    await this.setLoadingProjectSearch(true);
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/projects/?limit=6&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingProjectSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setLoadingProjectSearch(false);
      throw new Error('Not OK');
    } else {
      await this.setLoadingProjectSearch(false);
      const json = await res.json();
      if (json) {
        const findProjectResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id;
          newResults.title = obj.name;
          newResults.description = obj.shortName;
          return newResults;
        });
        this.setState({ findProjectResults });
      } else {
        const noResultsMessage = `${t('No results found', { ns: TRANSLATION_FILES.translation })}.`;
        this.setState({ noResultsMessage });
      }
    }
  }
  async fetchPackagePricings() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/projects/${this.state.projectID}/package_pricings/?sortByEnabled=true`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const json = await res.json();
      const packagePricingList = this.editPackagePricingData(json);
      await this.setComponentState({
        packagePricingList,
      });
    }
    await this.setLoading(false);
  }
  async bulkRecalculateUnitBookingPrice() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const { projectID } = this.state;
    let res;
    try {
      res = await store.dispatch(fetchM(`/settings/recalculate_unit_booking_pricing/?projectID=${projectID}`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      const { updatedCount } = data;
      await store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('{{count}} active bookings successfully updated unit selling price', { count: updatedCount, ns: TRANSLATION_FILES.translation }) }));
    }
    await this.setLoading(false);
  }
  async bulkApplyLatestBookingPackagePricing() {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const { projectPackagePricingID } = this.state;
    let res;
    try {
      res = await store.dispatch(fetchM(`/settings/apply_latest_booking_package_pricing/?projectPackagePricingID=${projectPackagePricingID}`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      const { updatedCount } = data;
      await store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Selected pricing package successfully updated in {{count}} active bookings', { count: updatedCount, ns: TRANSLATION_FILES.translation }) }));
    }
    await this.setLoading(false);
  }
  async previewAddressFormat(validations, data, addressSettings) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const errors = validations.filter(v => !v.isValid);

    const addressSettingValidations = await this.addressSettingList.validate();
    errors.concat(addressSettingValidations.filter(v => !v.isValid));

    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      this.setLoading(false);
      return;
    }

    const payload = {
      format: data.addressFormatTemplate,
    };
    addressSettings.forEach((as) => {
      payload[_.camelCase(as.columnName)] = as.label;
    });

    let res;
    try {
      res = await store.dispatch(fetchM('/settings/preview_address_format/', {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(payload),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const previewData = await res.json();
      await this.setComponentState({
        previewFormat: previewData.preview,
      });
    }
    await this.setLoading(false);
  }
  async fetchAddressSettingActivities() {
    await this.setActivitiesLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = {
      limit: 5,
      page: 1,
    };
    let res;
    try {
      res = await store.dispatch(fetchM(`/address_settings/activities/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setActivitiesLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setActivitiesLoading(false);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    } else {
      const addressSettingActivities = await res.json();
      await this.setComponentState({
        addressSettingActivities,
      });
      await this.setActivitiesLoading(false);
    }
  }
  async fetchCurrencySetting(companyID, data) {
    await this.setCurrencySettingLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    const newData = { ...data };
    try {
      res = await store.dispatch(fetchM(`/company/${companyID}/currency_setting/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setCurrencySettingLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setCurrencySettingLoading(false);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    } else {
      const currencySetting = await res.json();
      newData.currencySetting = currencySetting;
      // set default data
      if (!currencySetting.id) {
        newData.currencySetting.isAbbreviationEnabled = false;
        newData.currencySetting.abbreviationDecimalPoints = 2;
      }
      await this.setComponentState({
        data: newData,
      });
      await this.setCurrencySettingLoading(false);
    }
  }
  async fetchUnitCustomFieldSettings() {
    await this.setUnitCustomSettingsLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/unit_custom_fields/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setUnitCustomSettingsLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setUnitCustomSettingsLoading(false);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    } else {
      const unitCustomFieldSettingsData = await res.json() || [];
      await this.setComponentState({
        unitCustomFieldSettings: unitCustomFieldSettingsData,
        oriUnitCustomFieldSettings: clone(unitCustomFieldSettingsData),
      });
      await this.setUnitCustomSettingsLoading(false);
    }
  }
  editImageSrc = (data = []) => {
    const newData = [];
    data.forEach((d) => {
      const editData = {};
      editData.value = d.id;
      editData.text = d.shortName;
      const editImage = {};
      editData.image = editImage;
      editData.image.avatar = true;
      if (d.pictureKey !== '') {
        editData.image.src = AWSUrl(this.props.appConfig, `${d.pictureKey}010.jpg`);
      } else {
        editData.image.src = '/assets/images/placeholder_x100.jpg';
      }
      newData.push(editData);
    });
    return newData;
  }
  editPackagePricingData = (data) => {
    if (data) {
      const enabledData = [];
      const disabledData = [];
      data.forEach((d) => {
        const editData = {};
        editData.value = d.id;
        editData.text = d.name;
        if (d.isEnabled) {
          enabledData.push(editData);
        } else {
          disabledData.push(editData);
        }
      });
      const newData = [];
      if (enabledData.length > 0) {
        newData.push({ header: true, text: 'Enabled' });
        newData.push(...enabledData);
      }
      if (disabledData.length > 0) {
        newData.push({ header: true, text: 'Disabled' });
        newData.push(...disabledData);
      }
      return newData;
    }
    return [];
  }
  handleSearchProject = (projectKeyword) => {
    const { t } = this.props;
    clearTimeout(this.setTimer);
    // always reset results to null before finding
    const findProjectResults = [];
    const noResultsMessage = `${t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    this.setState({ findProjectResults, noResultsMessage, projectKeyword }, () => {
      if (projectKeyword !== '') {
        this.setTimer = setTimeout(() => {
          this.searchProjects(projectKeyword);
        }, 500);
      }
    });
  }
  handleSelectProject = (project) => {
    this.setState({
      projectID: project.key,
      projectKeyword: project.title,
      projectPackagePricingID: '',
    }, () => {
      this.fetchPackagePricings();
    });
  }
  handleSelectPackage = (projectPackagePricingID) => {
    this.setState({ projectPackagePricingID });
  }
  checkActiveTab(name) {
    return this.state.currentTab === name ? 'display_inline_block' : 'display_inline_block hidden';
  }
  checkSaveDisabled = () => {
    const { data, oriData, addressSettings, oriAddressSettings, unitCustomFieldSettings, oriUnitCustomFieldSettings, financeSources, oriFinanceSources, reservationTokenSettings, oriReservationTokenSettings } = this.state;
    if (JSON.stringify(data) !== JSON.stringify(oriData)
    || JSON.stringify(addressSettings) !== JSON.stringify(oriAddressSettings)
    || JSON.stringify(unitCustomFieldSettings) !== JSON.stringify(oriUnitCustomFieldSettings)
    || JSON.stringify(financeSources) !== JSON.stringify(oriFinanceSources)
    || JSON.stringify(reservationTokenSettings) !== JSON.stringify(oriReservationTokenSettings)) {
      return false;
    }
    return true;
  }
  prepareTempData = (data) => {
    const tempData = clone(SystemSettings.defaultTempData);
    if (data.canManagePaymentSupervisor) {
      tempData.userRoleManagePayment.push('canManagePaymentSupervisor');
    }
    if (data.canManagePaymentSalesManager) {
      tempData.userRoleManagePayment.push('canManagePaymentSalesManager');
    }
    if (data.canManagePaymentSalesAdmin) {
      tempData.userRoleManagePayment.push('canManagePaymentSalesAdmin');
    }
    return tempData;
  }
  hasAdminAccess(props = this.props) {
    const { auth } = props;
    if (auth.isAdmin || auth.isAdminBasic || auth.isSuperAdmin) {
      return true;
    }
    return false;
  }
  handleSave = (e) => {
    if (e) e.preventDefault();
    const { data, addressSettings, reservationTokenSettings, oriReservationTokenSettings } = this.state;
    AppForm.validate(this.validation, data)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });
        this.updateSystemSettings(validations, data, addressSettings);
        if (this.canAccessReservationTokenSettings() && JSON.stringify(reservationTokenSettings) !== JSON.stringify(oriReservationTokenSettings)) {
          this.saveReservationTokenSettings(true);
        }
      });
  }
  handleChangeTab = (e, { name, value }) => {
    const currentTab = name || value;
    this.setState({ currentTab });
  }
  handleResize = () => {
    const state = {};
    const topMenuIsTab = window.innerWidth <= 590;
    if (topMenuIsTab !== this.state.topMenuIsTab) {
      state.topMenuIsTab = topMenuIsTab;
    }
    const menuIsTab = window.innerWidth >= 991;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const menuIsVertical = window.innerWidth >= 991;
    if (menuIsVertical !== this.state.menuIsVertical) {
      state.menuIsVertical = menuIsVertical;
    }
    this.setState({ ...state });
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleCheckBoxChange = (event, d) => {
    const { data } = this.state;
    data[d.name] = !data[d.name];
    // custom value settings
    if (d.name === 'allowStaffEditBookingStatus') {
      data.allowStaffEditBookingStatusCancel = d.checked;
    }
    if (d.name === 'arBookingExpIsEnabled') {
      data.arBookingExpMoreThanMinutes = '0';
      data.arBookingExpNricPicIsEnabled = false;
      data.arBookingExpAllNricPicsIsEnabled = false;
      data.arBookingExpUnpaidIsEnabled = false;
      data.arBookingExpMortgageEnabled = false;
      data.arAgingBookingExpMoreThanMinutes = '0';
      data.arAgingBookingExpReservedIsEnabled = false;
      data.arAgingBookingExpBookedIsEnabled = false;
      this.setState({ applyArToAllProjects: false, applyAgingArToAllProjects: false });
    }
    if (d.name === 'isAbbreviationEnabled') {
      data.currencySetting.isAbbreviationEnabled = d.checked;
    }
    if (d.name === 'docxTemplaterIsEnabled') {
      if (!d.checked) data.docxTemplaterDebuggingIsEnabled = false;
    }
    this.setState({ data });
  }
  handleInputChange = (event, { name, value }) => {
    const { data } = this.state;
    data[name] = value;
    if (data[name] === 'arBookingExpMoreThanMinutes' || data[name] === 'arAgingBookingExpMoreThanMinutes') {
      if (value === '') {
        data[name] = '0';
      } else {
        data[name] = value.toString();
      }
    }
    if (name === 'abbreviationDecimalPoints') {
      data.currencySetting.abbreviationDecimalPoints = value;
    }
    this.setState({ data });
  }
  handleSelectChange = (event, { name, value }) => {
    const { data } = this.state;
    data[name] = value;
    this.setState({ data });
  }
  handleMultiDropdownToBoolChange = (e, d) => {
    const state = this.state;
    const value = d.value || [];
    d.options.forEach((o) => {
      if (o.disabled && !value.includes(o.value)) value.push(o.value);
    });
    state.tempData[d.name] = value;
    state.data = clone({
      ...state.oriData,
      canManagePaymentSupervisor: false,
      canManagePaymentSalesManager: false,
      canManagePaymentSalesAdmin: false,
    });
    d.options.forEach((o) => {
      d.value.forEach((v) => {
        if (o.value === v) {
          if (!o.disabled) state.data[v] = true;
        }
      });
    });
    this.setState({ ...state });
  }
  handleOnChangeCustomFieldData = (d) => {
    this.setState({ unitCustomFieldSettings: d });
  }
  handleRequirementSettings = (e) => {
    const { data, applyArToAllProjects } = this.state;
    e.preventDefault();

    const applyAllProjectsState = !applyArToAllProjects;

    if (!applyAllProjectsState) {
      data.arBookingExpMoreThanMinutes = '0';
      data.arBookingExpNricPicIsEnabled = false;
      data.arBookingExpAllNricPicsIsEnabled = false;
      data.arBookingExpUnpaidIsEnabled = false;
      data.arBookingExpMortgageEnabled = false;

      this.setState({ data });
    }
    this.setState({ applyArToAllProjects: applyAllProjectsState });
  }
  handleAgingRequirementSettings = (e) => {
    const { data, applyAgingArToAllProjects } = this.state;
    e.preventDefault();

    const applyAllProjectsState = !applyAgingArToAllProjects;

    if (!applyAllProjectsState) {
      data.arAgingBookingExpMoreThanMinutes = '0';
      data.arAgingBookingExpReservedIsEnabled = false;
      data.arAgingBookingExpBookedIsEnabled = false;

      this.setState({ data });
    }
    this.setState({ applyAgingArToAllProjects: applyAllProjectsState });
  }
  handleRegionsChange = (e, { value }) => {
    const { data } = this.state;
    data.regions = value;
    this.setState({ data });
  }
  handleAdditionRegion = (e, { value }) => {
    if (value) {
      this.setState({
        regionOptions: [{ text: value, value }, ...this.state.regionOptions],
      });
    }
  }
  handleTownshipsChange = (e, { value }) => {
    const { data } = this.state;
    data.townships = value;
    this.setState({ data });
  }
  handleAdditionTownship = (e, { value }) => {
    if (value) {
      this.setState({
        townshipOptions: [{ text: value, value }, ...this.state.townshipOptions],
      });
    }
  }
  handleRecalculateUnitPackagePricing = (e) => {
    e.preventDefault();
    this.bulkRecalculateUnitPackagePricing();
  }
  handleAdditionCooldown = (e, { value }) => {
    const numberVal = value.replace(/\D/g, '').substring(0, 9);
    if (numberVal) {
      const { data } = this.state;
      let { cooldownOptions } = this.state;
      const exists = this.state.cooldownOptions.findIndex(co => co.value === numberVal);
      if (exists === -1) {
        cooldownOptions = [{ key: numberVal, text: numberVal, value: numberVal }, ...this.state.cooldownOptions];
      }
      data.unitCooldownTimeMinutes = numberVal;
      this.setState({
        cooldownOptions,
        data,
      });
    }
  }
  handleChangeCooldown = (e, { value }) => {
    const { data } = this.state;
    data.unitCooldownTimeMinutes = value;
    this.setState({ data });
  }
  handleChangeSMSTemplate = (e, { name, value }) => {
    const { data } = this.state;
    data[name] = value;
    this.setState({ data });
  }
  handleAdditionCache = (e, { value }) => {
    const numberVal = value.replace(/\D/g, '').substring(0, 9);
    if (numberVal) {
      const { data } = this.state;
      let { cacheOptions } = this.state;
      const exists = this.state.cacheOptions.findIndex(co => co.value === numberVal);
      if (exists === -1) {
        cacheOptions = [{ key: numberVal, text: numberVal, value: numberVal }, ...this.state.cacheOptions];
      }
      data.salesChartCacheMinutes = numberVal;
      this.setState({
        cacheOptions,
        data,
      });
    }
  }
  handleChangeCache = (e, { value }) => {
    const { data } = this.state;
    data.salesChartCacheMinutes = value;
    this.setState({ data });
  }
  handlePreview = (e) => {
    if (e) e.preventDefault();
    const { data, addressSettings } = this.state;
    AppForm.validate(this.validation, data)
      .then((validations) => {
        this.setState({
          errMessages: validations.filter(v => !v.isValid),
        });

        this.previewAddressFormat(validations, data, addressSettings);
      });
  }
  handleAddressSettingChange = (addressSettings) => {
    this.setState({
      addressSettings,
    });
  }
  handleAddressSettingOriChange = (addressSettings) => {
    this.setState({
      addressSettings,
      oriAddressSettings: clone(addressSettings),
    });
  }
  handleFinanceSourcesChange = (financeSources) => {
    this.setState({
      financeSources,
    });
  }
  handleFinanceSourcesOriChange = (financeSources) => {
    this.setState({
      financeSources,
      oriFinanceSources: clone(financeSources),
    });
  }
  async fetchReservationTokenSettings() {
    this.setState({ reservationTokenLoading: true });
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/reservation_token/', {
        credentials: 'include',
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      }));
    } catch (e) {
      this.setState({ reservationTokenLoading: false });
      store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      const settings = {
        priceMinor: data ? (data.priceMinor || 0) : 0,
        validityDurationDays: data ? (data.validityDurationDays || 0) : 0,
        limitPerOpportunity: data ? (data.limitPerOpportunity || 0) : 0,
        currencyCode: data ? (data.currencyCode || 'MYR') : 'MYR',
      };
      this.setState({
        reservationTokenSettings: settings,
        oriReservationTokenSettings: { ...settings },
        token: res.headers.get('X-Csrf-Token') || this.state.token,
      });
    }
    this.setState({ reservationTokenLoading: false });
  }
  async saveReservationTokenSettings(suppressSuccessMessage = false) {
    this.setState({ reservationTokenLoading: true });
    const { store } = this.context;
    const { t } = this.props;
    const { reservationTokenSettings } = this.state;
    const payload = {
      priceMinor: Number(reservationTokenSettings.priceMinor) || 0,
      validityDurationDays: Number(reservationTokenSettings.validityDurationDays) || 0,
      limitPerOpportunity: Number(reservationTokenSettings.limitPerOpportunity) || 0,
      currencyCode: reservationTokenSettings.currencyCode || 'MYR',
    };
    if (payload.priceMinor < 0 || payload.validityDurationDays < 0 || payload.limitPerOpportunity < 0) {
      store.dispatch(flashErrorMessage({ message: t('Values must be 0 or greater', { ns: TRANSLATION_FILES.translation }) }));
      this.setState({ reservationTokenLoading: false });
      return;
    }
    try {
      await store.dispatch(fetchM('/settings/reservation_token/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(payload),
      }));
    } catch (err) {
      this.setState({ reservationTokenLoading: false });
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    this.setState({
      reservationTokenLoading: false,
      oriReservationTokenSettings: { ...reservationTokenSettings },
    });
    if (!suppressSuccessMessage) {
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Reservation token settings saved successfully', { ns: TRANSLATION_FILES.translation }),
      }));
    }
  }
  handleReservationTokenInputChange = (e, { name, value }) => {
    const { reservationTokenSettings } = this.state;
    this.setState({ reservationTokenSettings: { ...reservationTokenSettings, [name]: value } });
  }
  getAvailableTimeOptions = () => {
    const { t } = this.props;
    const startHour = 0;  // Midnight
    const endHour = 23;   // 11 PM

    // Create an array listing all time in 24 hour format spaced in one hour intervals.
    return Array.from({ length: (endHour - startHour) + 1 }, (e, index) => {
      const hour = startHour + index;
      const isPM = hour >= 12;
      const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
      const timeLabel = `${hour.toString().padStart(2, '0')}:00`;
      const amPmText = isPM ? t('PM', { ns: TRANSLATION_FILES.constants }) : t('AM', { ns: TRANSLATION_FILES.constants });
      return { key: hour, text: `${formattedHour}:00 ${amPmText}`, value: `${timeLabel}:00` };
    });
  }
  canAccessReservationTokenSettings = () => {
    const { auth } = this.props;
    return auth.isHeadquarters || auth.isAdminCommunity;
  }
  tabs = [
    {
      name: 'access',
      value: 'access',
      text: 'Access Management',
      fields: [],
    },
    {
      name: 'features',
      value: 'features',
      text: 'Features',
      fields: [],
    },
    {
      name: 'pricing_package',
      value: 'pricing_package',
      text: 'Pricing Package',
      fields: [],
    },
    {
      name: 'project',
      value: 'project',
      text: 'Project Settings',
      fields: [],
    },
    {
      name: 'cooldown',
      value: 'cooldown',
      text: 'Cooldown',
      fields: [],
    },
    {
      name: 'unit_field_management',
      value: 'unit_field_management',
      text: 'Unit Field Management',
      fields: [],
    },
    {
      name: 'address',
      value: 'address',
      text: 'Address settings',
      fields: [],
    },
    {
      name: 'source_of_financing',
      value: 'source_of_financing',
      text: 'Sources of Financing',
      fields: [],
    },
    this.canAccessReservationTokenSettings() && {
      name: 'reservation_token',
      value: 'reservation_token',
      text: 'Reservation Token',
      fields: [],
    },
  ];
  canManagePaymentOptions = [
    {
      key: 0,
      text: 'Headquarters',
      value: 'hq',
      disabled: true,
      icon: 'comment',
    },
    {
      key: 1,
      text: 'Supervisors',
      value: 'canManagePaymentSupervisor',
      icon: 'users',
    },
    {
      key: 2,
      text: 'Sales Managers',
      value: 'canManagePaymentSalesManager',
      icon: 'users',
    },
    {
      key: 3,
      text: 'Sales Admins',
      value: 'canManagePaymentSalesAdmin',
      icon: 'users',
    },
  ]
  cooldownOptions = [
    { key: 'o15', text: '15 (15 Minutes)', value: '15' },
    { key: 'o30', text: '30 (30 Minutes)', value: '30' },
    { key: 'o60', text: '60 (1 Hour)', value: '60' },
    { key: 'o180', text: '180 (3 Hours)', value: '180' },
    { key: 'o360', text: '360 (6 Hours)', value: '360' },
    { key: 'o720', text: '720 (12 Hours)', value: '720' },
    { key: 'o1440', text: '1440 (1 Day)', value: '1440' },
  ]
  cacheOptions = [
    { key: 'o30', text: '30 (30 Minutes)', value: '30' },
    { key: 'o60', text: '60 (1 Hour)', value: '60' },
    { key: 'o120', text: '120 (2 Hours)', value: '120' },
  ]
  render() {
    const { data, oriData, tempData, loading, currencySettingLoading, unitCustomFieldSettings, unitCustomSettingsLoading } = this.state;
    const { pathname } = this.props.location;
    const { t, i18n, auth } = this.props;
    const displayCountryCode = auth && auth.company && auth.company.countryCode;

    // Update moment locale when language changes
    const localeMap = { en: 'en-gb', vi: 'vi', id: 'id' };
    const momentLocale = localeMap[i18n.language] || 'en-gb';
    if (moment.locale() !== momentLocale) moment.locale(momentLocale);

    const links = [
      { text: 'System Settings', value: '/settings/system_settings/' },
      { text: 'Custom Options', value: '/settings/custom_options/' },
    ];
    const renderLabel = label => ({
      content: label.text,
      icon: 'users',
    });
    const smsTemplatesList = [
      { text: t('Default'), value: 'default' },
      ...this.state.smsTemplates,
    ];
    return (
      <Container>
        <NavBar
          links={
            this.state.topMenuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links.map(l => ({
                  ...l,
                  text: t(l.text),
                }))}
                onChange={this.handleMenu}
                value={pathname}
              />
              : links.map((link, key) => (
                <Menu.Item
                  key={key}
                  name={t(link.text)}
                  active={pathname === link.value}
                  onClick={e => this.handleMenu(e, link)}
                />
              ))
          }
          rightNav={
            <Button
              color="green"
              content={t('Save', { ns: TRANSLATION_FILES.translation })}
              disabled={this.state.loading || this.checkSaveDisabled()}
              onClick={this.handleSave}
            />}
        />
        <Grid>
          <Grid.Row>
            <Grid.Column width={16}>
              <Grid columns="equal" stackable doubling>
                <Dimmer style={{ zIndex: 20 }} active={loading} inverted>
                  <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                </Dimmer>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={16} computer={4}>
                    <Menu
                      fluid
                      widths={!this.state.menuIsTab ? 1 : null}
                      tabular={this.state.menuIsTab}
                      vertical={this.state.menuIsVertical}
                    >
                      {
                        !this.state.menuIsTab ?
                          <Dropdown
                            item
                            selectOnBlur={false}
                            options={this.tabs.filter(tb => tb).map((tb, k) => {
                              const tab = {
                                key: k,
                                text: t(tb.text),
                                name: tb.name,
                                value: tb.value,
                                label: this.state.errMessages.some(e => tb.fields.some(f => e.key === f)) ?
                                {
                                  color: 'red',
                                  content: '!',
                                } : null,
                              };
                              return tab;
                            })}
                            onChange={this.handleChangeTab}
                            value={this.state.currentTab}
                            disabled={this.state.loading}
                          />
                          : this.tabs.map((tab, key) => {
                            if (tab) {
                              return (
                                <Menu.Item
                                  key={key}
                                  name={tab.name}
                                  onClick={this.handleChangeTab}
                                  active={this.state.currentTab === tab.name}
                                >
                                  {t(tab.text)}
                                  {
                                    this.state.errMessages.some(e => tab.fields
                                      && tab.fields.some(f => e.key === f)) ?
                                        <Label color="red" floating={!this.state.menuIsVertical} content="!" />
                                      : null
                                  }
                                </Menu.Item>
                              );
                            }
                            return null;
                          })
                      }
                    </Menu>
                    <p style={{ textAlign: 'center' }}>
                      <i>
                        <b>{t('Settings Last Updated')}</b><br />
                        {oriData.updatedAt ? <span title={displayMoment(oriData.updatedAt, displayCountryCode).format('MMMM Do YYYY, h:mm a')}>{moment(oriData.updatedAt).fromNow()}</span> : ''}
                        {oriData.updatedByUserName ? (
                          <span>
                            &nbsp;- <Link to={oriData.updatedByUserAffiliateID ? `/users/${oriData.updatedByUserAffiliateID}/` : ''}>{oriData.updatedByUserName}</Link>
                          </span>
                        ) : ''}
                      </i>
                    </p>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('access')}>
                    <Divider horizontal>{t('Who Can Manage Payment?')}</Divider>
                    <Form.Group widths="equal">
                      <AppForm.Validate
                        ref={this.validation.canManagePaymentOptions}
                        onChange={this.handleMultiDropdownToBoolChange}
                      >
                        <Dropdown
                          options={this.canManagePaymentOptions.map(o => ({
                            ...o,
                            text: t(o.text, { ns: TRANSLATION_FILES.constants }),
                          }))}
                          fluid
                          multiple
                          name="userRoleManagePayment"
                          noResultsMessage={`${t('No more user roles')}.`}
                          placeholder={t('Select user roles access')}
                          renderLabel={renderLabel}
                          search
                          selection
                          value={tempData.userRoleManagePayment}
                        />
                      </AppForm.Validate>
                    </Form.Group>
                    <Divider horizontal>{t('Booking Status')}</Divider>
                    <Segment>
                      <List>
                        <List.Item>
                          <List.Icon name="user circle" />
                          <List.Content>
                            <List.Description>
                              <Form.Checkbox
                                label={t('Allow staff role to change booking statuses')}
                                checked={data.allowStaffEditBookingStatus}
                                name="allowStaffEditBookingStatus"
                                onChange={this.handleCheckBoxChange}
                              />
                            </List.Description>
                            <List.List>
                              <List.Item>
                                <List.Icon name="user circle" />
                                <List.Content>
                                  <List.Description>
                                    <Form.Checkbox
                                      label={t('Allow staff role to change booking status to cancelled')}
                                      checked={data.allowStaffEditBookingStatusCancel}
                                      disabled={!data.allowStaffEditBookingStatus}
                                      name="allowStaffEditBookingStatusCancel"
                                      onChange={this.handleCheckBoxChange}
                                    />
                                  </List.Description>
                                </List.Content>
                              </List.Item>
                            </List.List>
                          </List.Content>
                        </List.Item>
                      </List>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('sms')}>
                    <Divider horizontal>{t('SMS Templates')}</Divider>
                    <Grid.Column mobile={16} tablet={16} computer={16} style={{ marginTop: '1em' }}>
                      <div className="ui form">
                        <Form.Group widths="equal">
                          <Form.Select
                            label={t('Consent Pin SMS Template')}
                            options={smsTemplatesList}
                            placeholder={t('Consent Pin SMS Template')}
                            name="leadDropSMSTemplate"
                            search
                            selection
                            fluid
                            value={data.leadDropSMSTemplate}
                            noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                            onChange={this.handleChangeSMSTemplate}
                          />
                        </Form.Group>
                        <Form.Group widths="equal">
                          <Form.Select
                            label={t('Loan Enquiry Notification SMS Template')}
                            options={smsTemplatesList}
                            placeholder={t('Loan Enquiry Notification SMS Template')}
                            name="leadSuccessSMSTemplate"
                            search
                            selection
                            fluid
                            value={data.leadSuccessSMSTemplate}
                            noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                            onChange={this.handleChangeSMSTemplate}
                          />
                        </Form.Group>
                      </div>
                    </Grid.Column>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('features')}>
                    <Divider horizontal>{t('Overall Unit Reports')}</Divider>
                    <div className="ui form">
                      <Form.Group widths="equal" style={{ display: 'flex', alignItems: 'center' }}>
                        <Form.Select
                          label={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <span style={{ marginBottom: '0.3em' }}>{t('Auto generate overall unit report time', { ns: TRANSLATION_FILES.translation })}</span>
                              <Popup
                                className="srb"
                                content={
                                  <div>
                                    <p>{t('Auto-generation can only be triggered once per day. If the report has already been triggered today, any changes you make will take effect the following day.', { ns: TRANSLATION_FILES.translation })}</p>
                                  </div>
                                }
                                on="click"
                                wide
                                positionFixed
                                style={{ background: 'white', color: 'black', border: '3.5px solid #22242626', padding: '1em 1.5em' }}
                                position="bottom center"
                                trigger={
                                  <Button
                                    icon="question circle outline"
                                    size="small"
                                    style={{
                                      padding: '0.2em 0.3em',
                                      background: 'none',
                                      marginLeft: '0.2em',
                                      marginBottom: '0.2em',
                                      color: 'rgb(0, 151, 161)',
                                    }}
                                  />
                                }
                                pinned
                                inverted
                                onOpen={(e) => {
                                  e.preventDefault();
                                }}
                                onClose={(e) => {
                                  e.preventDefault();
                                }}
                              />
                            </div>
                          }
                          placeholder={t('Select auto generate overall unit report time', { ns: TRANSLATION_FILES.translation })}
                          name="generateOverallUnitReportTime"
                          value={data.generateOverallUnitReportTime}
                          onChange={this.handleSelectChange}
                          options={this.getAvailableTimeOptions()}
                          style={{ width: '40%' }}
                        />
                      </Form.Group>
                    </div>
                    <Divider horizontal>{t('Sharing')}</Divider>
                    <Form.Group widths="equal">
                      <Segment>
                        <Form.Checkbox
                          label={t('Allow whatsapp and text copy sharing for project unit')}
                          checked={data.allowUnitSocialShare}
                          name="allowUnitSocialShare"
                          onChange={this.handleCheckBoxChange}
                        />
                      </Segment>
                    </Form.Group>
                    <Divider horizontal>{t('Unit Holding', { ns: TRANSLATION_FILES.translation })}</Divider>
                    <p className="system-settings_description-text">{t('Units on hold will be converted to Delisted status with an additional On Hold flag. The flag will be removed once the unit status is updated manually to Available', { ns: TRANSLATION_FILES.translation })}</p>
                    <Form.Group widths="equal">
                      <Segment>
                        <Form.Checkbox
                          label={t('Turn on the "Hold Unit" Feature by default for all cancellations', { ns: TRANSLATION_FILES.translation })}
                          checked={data.defaultHoldDelistUnit}
                          name="defaultHoldDelistUnit"
                          onChange={this.handleCheckBoxChange}
                        />
                      </Segment>
                    </Form.Group>
                    {
                      !currencySettingLoading && data.currencySetting && data && isForeignCompany(data.company) && (
                        <div>
                          <Divider style={{ marginTop: '4em' }} horizontal>{t('Currency Abbreviation')}</Divider>
                          <Grid>
                            <Grid.Row>
                              <Grid.Column>
                                <Segment>
                                  <Form.Checkbox
                                    label={t('Enable currency abbreviation (eg: 100K, 1M)')}
                                    checked={data.currencySetting.isAbbreviationEnabled}
                                    name="isAbbreviationEnabled"
                                    onChange={this.handleCheckBoxChange}
                                  />
                                </Segment>
                              </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                              <Grid.Column>
                                <AppForm.Input
                                  label={t('Abbreviation decimal points')}
                                  name="abbreviationDecimalPoints"
                                  value={Number(data.currencySetting.abbreviationDecimalPoints)}
                                  validation={[required, {
                                    validate: numericRange,
                                    option: {
                                      min: 0,
                                    },
                                  }]}
                                  type="number"
                                  step="1"
                                  onChange={this.handleInputChange}
                                />
                              </Grid.Column>
                            </Grid.Row>
                          </Grid>
                        </div>
                      )
                    }
                    <Divider horizontal>{t('Booking Management', { ns: TRANSLATION_FILES.translation })}</Divider>
                    <div className="ui form">
                      <Form.Group widths="equal">
                        <Form.Checkbox
                          label={t('Disable Sold Date selection when changing booking status to Sold', { ns: TRANSLATION_FILES.translation })}
                          checked={data.disableSoldDateSelection}
                          name="disableSoldDateSelection"
                          onChange={this.handleCheckBoxChange}
                        />
                      </Form.Group>
                      <Form.Group widths="equal">
                        <Form.Checkbox
                          label={t('Disable Sold Date to be editable in Booking Overview', { ns: TRANSLATION_FILES.translation })}
                          checked={data.disableSoldDateEditing}
                          name="disableSoldDateEditing"
                          onChange={this.handleCheckBoxChange}
                        />
                      </Form.Group>
                      <Form.Group widths="equal">
                        <Form.Checkbox
                          label={t('Disable Cancelled Date to be editable in Booking Overview', { ns: TRANSLATION_FILES.translation })}
                          checked={data.disableCancelledDateEditing}
                          name="disableCancelledDateEditing"
                          onChange={this.handleCheckBoxChange}
                        />
                      </Form.Group>
                    </div>
                    <Divider horizontal>{t('Visibility')}</Divider>
                    <div className="ui form">
                      <Form.Group widths="equal">
                        <Form.Checkbox
                          label={t('Hide Tracker tab in Bookings')}
                          checked={data.bookingHideLoanTracker}
                          name="bookingHideLoanTracker"
                          onChange={this.handleCheckBoxChange}
                        />
                      </Form.Group>
                      <Form.Group widths="equal">
                        <Form.Checkbox
                          label={t('Hide \'First Time Buyer\' question in Bookings')}
                          checked={data.bookingHideFirstTimeBuyer}
                          name="bookingHideFirstTimeBuyer"
                          onChange={this.handleCheckBoxChange}
                        />
                      </Form.Group>
                    </div>
                    <Divider horizontal>{t('Payment')}</Divider>
                    <Form.Group widths="equal">
                      <Form.Checkbox
                        label={t('Enable Virtual Account for Payment')}
                        checked={data.virtualAccountIsEnabled}
                        name="virtualAccountIsEnabled"
                        onChange={this.handleCheckBoxChange}
                      />
                    </Form.Group>
                    <p style={{ fontSize: '12px', marginLeft: '2.2em', marginTop: '5px' }}>
                      {t('Enabling this will add Virtual Account for each unit as one of the payment method for booking payment')}
                    </p>
                    <Divider horizontal>{t('Quotation', { ns: TRANSLATION_FILES.translation })}</Divider>
                    <Form.Group widths="equal">
                      <Form.Checkbox
                        label={t('Enable Generate Quotation feature')}
                        checked={data.generateQuotationIsEnabled}
                        name="generateQuotationIsEnabled"
                        onChange={this.handleCheckBoxChange}
                      />
                    </Form.Group>
                    <p style={{ fontSize: '12px', marginLeft: '2.2em', marginTop: '5px' }}>
                      {t('Enabling this will add Generate Quotation feature within Unit information page')}
                    </p>
                    <Divider horizontal>{t('Notes')}</Divider>
                    <div className="ui form">
                      <AppForm.Input
                        label={t('Notes placeholder for agents', { ns: TRANSLATION_FILES.translation })}
                        name="notesExternalPlaceholder"
                        value={data.notesExternalPlaceholder}
                        onChange={this.handleInputChange}
                        style={{ marginTop: '1em' }}
                      />
                    </div>
                    <Divider horizontal>{t('Data Formatting', { ns: TRANSLATION_FILES.translation })}</Divider>
                    <div className="ui form">
                      <Form.Checkbox
                        label={t('Enable Uppercase Formatting for Purchaser Information in Bookings', { ns: TRANSLATION_FILES.translation })}
                        checked={data.uppercasePurchaserInfoIsEnabled}
                        name="uppercasePurchaserInfoIsEnabled"
                        onChange={this.handleCheckBoxChange}
                      />
                    </div>
                    <Divider horizontal>{t('FORM TEMPLATE', { ns: TRANSLATION_FILES.translation })}</Divider>
                    <div className="ui form">
                      <Form.Checkbox
                        label={t('Enable Form Template in Projects', { ns: TRANSLATION_FILES.translation })}
                        checked={data.docxTemplaterIsEnabled}
                        name="docxTemplaterIsEnabled"
                        onChange={this.handleCheckBoxChange}
                      />
                      <div style={{ marginLeft: '2em' }}>
                        <Form.Checkbox
                          label={t('Enable Form Template Debugging Mode', { ns: TRANSLATION_FILES.translation })}
                          checked={data.docxTemplaterDebuggingIsEnabled}
                          name="docxTemplaterDebuggingIsEnabled"
                          onChange={this.handleCheckBoxChange}
                          disabled={!data.docxTemplaterIsEnabled}
                        />
                      </div>
                    </div>
                    <Divider horizontal>{t('Print Form Visibility')}</Divider>
                    <div className="ui form">
                      <Form.Checkbox
                        label={t('Allow all Business Unit to view newly added Form by default')}
                        checked={data.allowAllBusinessUnitViewNewForm}
                        name="allowAllBusinessUnitViewNewForm"
                        onChange={this.handleCheckBoxChange}
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('pricing_package')}>
                    <Divider horizontal>{t('Pricing Package')}</Divider>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <Segment>
                            <Button
                              onClick={() => this.bulkRecalculateUnitPackagePricing()}
                            >
                              <Icon name="refresh" />
                              {t('Recalculate Pricing Package In All Project Units')}
                            </Button>
                          </Segment>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <Divider horizontal>{t('Booking')}</Divider>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <Segment>
                            <Grid verticalAlign="middle" className="booking-list">
                              <Grid.Row className="toolbar">
                                <Grid.Column width={16}>
                                  <Grid
                                    className="filters"
                                    columns="equal"
                                    textAlign="left"
                                    verticalAlign="middle"
                                  >
                                    <Grid.Row>
                                      <Grid.Column className="filter">
                                        <BookingSearchList
                                          filterName="projectKeyword"
                                          icon="find"
                                          isActive={this.state.projectKeyword.length > 0}
                                          loading={this.state.loadingProjectSearch}
                                          noResultsMessage={this.state.noResultsMessage}
                                          onChange={this.handleSearchProject}
                                          onSelect={this.handleSelectProject}
                                          placeholder={t('Find Project')}
                                          results={this.state.findProjectResults}
                                          value={this.state.projectKeyword}
                                          disabled={this.state.loading}
                                        />
                                      </Grid.Column>
                                      <Grid.Column className="filter">
                                        <BookingSelectList
                                          filterName="projectPackagePricingID"
                                          onChange={this.handleSelectPackage}
                                          options={this.state.packagePricingList}
                                          placeholder={t('Select {{title}}', { title: t('Pricing Package') })}
                                          value={this.state.projectPackagePricingID}
                                          disabled={this.state.loading || this.state.packagePricingList.length < 1}
                                        />
                                      </Grid.Column>
                                    </Grid.Row>
                                  </Grid>
                                </Grid.Column>
                              </Grid.Row>
                              <Grid.Row columns="equal">
                                <Grid.Column>
                                  <Button
                                    onClick={() => this.bulkRecalculateUnitBookingPrice()}
                                    disabled={!this.state.projectID}
                                  >
                                    <Icon name="refresh" />
                                    {t('Recalculate Unit Selling Price In Active Bookings')}
                                  </Button>
                                </Grid.Column>
                                <Grid.Column>
                                  <Button
                                    onClick={() => this.bulkApplyLatestBookingPackagePricing()}
                                    disabled={!this.state.projectPackagePricingID}
                                  >
                                    <Icon name="refresh" />
                                    {t('Apply latest Pricing Package In Active Bookings')}
                                  </Button>
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                          </Segment>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('unit_field_management')}>
                    <Grid.Column stretched>
                      {
                      !unitCustomSettingsLoading ? (
                        <Form>
                          <CustomField
                            data={unitCustomFieldSettings || []}
                            type="unit"
                            onChangeData={this.handleOnChangeCustomFieldData}
                          />
                        </Form>
                      ) : (
                        <Dimmer
                          inverted style={{ zIndex: 1 }}
                          active
                        >
                          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                        </Dimmer>
                      )
                    }
                      <Divider horizontal style={{ marginTop: '2rem', marginBottom: '2rem' }} />
                      <DelistReasonsList
                        isHeadquarters={this.props.auth.isHeadquarters}
                        isSuperAdmin={this.props.auth.isSuperAdmin}
                        isAdminBasic={this.props.auth.isAdminBasic}
                      />
                    </Grid.Column>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('cooldown')}>
                    <Divider horizontal>{t('Booking Reservation Cooldown')}</Divider>
                    <p>{t('Booking cooldown can be enabled to prevent External Agents from re-booking the unit with a Cancelled or Expired booking for a specified amount of time')}.</p>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                          <Form.Group widths="equal">
                            <Segment>
                              <Form.Checkbox
                                toggle
                                label={t(data.unitCooldownIsEnabled ? 'Cooldown Is On' : 'Cooldown Is Off')}
                                name="unitCooldownIsEnabled"
                                checked={data.unitCooldownIsEnabled}
                                onChange={this.handleCheckBoxChange}
                              />
                            </Segment>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={16} computer={16} style={{ marginTop: '1em' }}>
                          <div className="ui form">
                            <Form.Group widths="equal">
                              <Form.Select
                                label={t('Cooldown Minutes (choose or fill in a custom amount)')}
                                options={this.state.cooldownOptions.map(c => ({ ...c, text: t(c.text, { ns: TRANSLATION_FILES.translation }) }))}
                                placeholder={t('Cooldown Minutes')}
                                name="unitCooldownTimeMinutes"
                                search
                                selection
                                fluid
                                allowAdditions
                                onAddItem={this.handleAdditionCooldown}
                                noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                value={data.unitCooldownTimeMinutes || ''}
                                onChange={this.handleChangeCooldown}
                                disabled={!data.unitCooldownIsEnabled}
                              />
                            </Form.Group>
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('auto_release')}>
                    <Divider horizontal>{t('Auto-Release')}</Divider>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={3} computer={3}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Unit auto release')} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(data.arBookingExpIsEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arBookingExpIsEnabled"
                                  checked={data.arBookingExpIsEnabled}
                                  onChange={this.handleCheckBoxChange}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={13} computer={13} />
                      </Grid.Row>
                    </Grid>
                    <Divider horizontal>
                      <Form.Checkbox
                        label={t('Apply auto release settings to all project')}
                        checked={this.state.applyArToAllProjects}
                        name="applyArToAllProjects"
                        onChange={this.handleRequirementSettings}
                        style={{ fontWeight: 'bold' }}
                        disabled={!data.arBookingExpIsEnabled}
                      />
                    </Divider>
                    <AppForm.Input
                      label={t('Auto release timer (hours)')}
                      name="arBookingExpMoreThanMinutes"
                      value={data ? Number(data.arBookingExpMoreThanMinutes) : 0}
                      validation={[required, {
                        validate: numericRange,
                        option: {
                          min: !this.state.applyArToAllProjects ? 0 : 0.1,
                        },
                      }]}
                      step="0.1"
                      onChange={this.handleInputChange}
                      ref={this.validation.arBookingExpMoreThanMinutes}
                      type="number"
                      disabled={!data.arBookingExpIsEnabled || !this.state.applyArToAllProjects}
                    />
                    {!isVietnamCompany(this.props.auth) && (
                    <Grid style={{ marginTop: '0.5em' }}>
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={4} computer={3}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Upload buyer\'s IC', { ns: TRANSLATION_FILES.translation })} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(data.arBookingExpNricPicIsEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arBookingExpNricPicIsEnabled"
                                  checked={data.arBookingExpNricPicIsEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!data.arBookingExpIsEnabled || !this.state.applyArToAllProjects}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={4} computer={3}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Additional buyer\'s IC', { ns: TRANSLATION_FILES.translation })} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(data.arBookingExpAllNricPicsIsEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arBookingExpAllNricPicsIsEnabled"
                                  checked={data.arBookingExpAllNricPicsIsEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!data.arBookingExpIsEnabled || !this.state.applyArToAllProjects}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={4} computer={3}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Booking fee payment')} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(data.arBookingExpUnpaidIsEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arBookingExpUnpaidIsEnabled"
                                  checked={data.arBookingExpUnpaidIsEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!data.arBookingExpIsEnabled || !this.state.applyArToAllProjects}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={4} computer={3}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Mortgage')} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(data.arBookingExpMortgageEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arBookingExpMortgageEnabled"
                                  checked={data.arBookingExpMortgageEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!data.arBookingExpIsEnabled || !this.state.applyArToAllProjects}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column only="computer" computer={4} />
                      </Grid.Row>
                    </Grid>
                    )}
                    <Divider horizontal>
                      <Form.Checkbox
                        label={t('Apply time limit settings to all project')}
                        checked={this.state.applyAgingArToAllProjects}
                        name="applyAgingArToAllProjects"
                        onChange={this.handleAgingRequirementSettings}
                        style={{ fontWeight: 'bold' }}
                        disabled={!data.arBookingExpIsEnabled}
                      />
                    </Divider>
                    <AppForm.Input
                      label={t('Time Limit timer (hours)')}
                      name="arAgingBookingExpMoreThanMinutes"
                      value={data ? Number(data.arAgingBookingExpMoreThanMinutes) : 0}
                      validation={[required, {
                        validate: numericRange,
                        option: {
                          min: !this.state.applyAgingArToAllProjects ? 0 : 0.1,
                        },
                      }]}
                      step="0.1"
                      onChange={this.handleInputChange}
                      ref={this.validation.arAgingBookingExpMoreThanMinutes}
                      type="number"
                      style={{ marginTop: '1em' }}
                      disabled={!data.arBookingExpIsEnabled || !this.state.applyAgingArToAllProjects}
                    />
                    <Grid style={{ marginTop: '0.5em' }}>
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={4} computer={3}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Reserved', { ns: TRANSLATION_FILES.constants })} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(data.arAgingBookingExpReservedIsEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arAgingBookingExpReservedIsEnabled"
                                  checked={data.arAgingBookingExpReservedIsEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!data.arBookingExpIsEnabled || !this.state.applyAgingArToAllProjects}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={4} computer={3}>
                          <Form.Group className="form-label">
                            <Form.Field label={t('Booked', { ns: TRANSLATION_FILES.constants })} />
                          </Form.Group>
                          <Form.Group className="form-mb1">
                            <Form.Field>
                              <Segment>
                                <Form.Checkbox
                                  toggle
                                  label={t(data.arAgingBookingExpBookedIsEnabled ? 'On' : 'Off', { ns: TRANSLATION_FILES.translation })}
                                  name="arAgingBookingExpBookedIsEnabled"
                                  checked={data.arAgingBookingExpBookedIsEnabled}
                                  onChange={this.handleCheckBoxChange}
                                  disabled={!data.arBookingExpIsEnabled || !this.state.applyAgingArToAllProjects}
                                />
                              </Segment>
                            </Form.Field>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column only="tablet computer" tablet={8} computer={10} />
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('cache')}>
                    <Divider horizontal>{t('Storey Plan Cache')}</Divider>
                    <p>{t('Improves storey plan page loading time (does not affect realtime status updates)')}.</p>
                    <Grid>
                      <Grid.Row>
                        <Grid.Column mobile={16} tablet={16} computer={16}>
                          <Form.Group widths="equal">
                            <Segment>
                              <Form.Checkbox
                                toggle
                                label={t(data.salesChartCacheIsEnabled ? 'Cache Is On' : 'Cache Is Off')}
                                name="salesChartCacheIsEnabled"
                                checked={data.salesChartCacheIsEnabled}
                                onChange={this.handleCheckBoxChange}
                              />
                            </Segment>
                          </Form.Group>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={16} computer={16} style={{ marginTop: '1em' }}>
                          <div className="ui form">
                            <Form.Group widths="equal">
                              <Form.Select
                                label={t('Cache Minutes (choose or fill in a custom amount)')}
                                options={this.state.cacheOptions.map(c => ({ ...c, text: t(c.text, { ns: TRANSLATION_FILES.translation }) }))}
                                placeholder={t('Cache Minutes')}
                                name="salesChartCacheMinutes"
                                search
                                selection
                                fluid
                                allowAdditions
                                onAddItem={this.handleAdditionCache}
                                value={data.salesChartCacheMinutes || ''}
                                noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                                onChange={this.handleChangeCache}
                                disabled={!data.salesChartCacheIsEnabled}
                              />
                            </Form.Group>
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('project')}>
                    <Divider horizontal>{t('Region')}</Divider>
                    <Form.Group widths="equal">
                      <Dropdown
                        options={this.state.regionOptions}
                        fluid
                        multiple
                        name="regions"
                        placeholder={t('Enter / select region')}
                        search
                        selection
                        value={data.regions || []}
                        allowAdditions
                        onAddItem={this.handleAdditionRegion}
                        onChange={(e, { value }) => this.handleRegionsChange(e, { value })}
                        noResultsMessage={`${t('No results found', { ns: TRANSLATION_FILES.translation })}.`}
                      />
                    </Form.Group>
                    <Divider horizontal>{t('Township')}</Divider>
                    <Form.Group widths="equal">
                      <Dropdown
                        options={this.state.townshipOptions}
                        fluid
                        multiple
                        name="townships"
                        placeholder={t('Enter / select township')}
                        search
                        selection
                        value={data.townships || []}
                        allowAdditions
                        onAddItem={this.handleAdditionTownship}
                        onChange={(e, { value }) => this.handleTownshipsChange(e, { value })}
                        noResultsMessage={`${t('No results found', { ns: TRANSLATION_FILES.translation })}.`}
                      />
                    </Form.Group>
                    <Divider horizontal>{t('Agency Allocation', { ns: TRANSLATION_FILES.translation })}</Divider>
                    <Form.Group widths="equal">
                      <Form.Select
                        label={t('Agency Allocation Logic', { ns: TRANSLATION_FILES.translation })}
                        name="agencyAllocationAllocateAll"
                        options={[
                          { key: 'allocateToAll', text: t('Allocate to all', { ns: TRANSLATION_FILES.translation }), value: true },
                          { key: 'allocateToNone', text: t('Allocate to none', { ns: TRANSLATION_FILES.translation }), value: false },
                        ]}
                        value={Boolean(data.agencyAllocationAllocateAll)}
                        onChange={this.handleSelectChange}
                        selection
                        fluid
                      />
                    </Form.Group>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('address')}>
                    <Divider horizontal>{t('Address format')}</Divider>
                    <Grid
                      columns="equal"
                      stackable
                      doubling
                      verticalAlign="middle"
                      style={{ marginBottom: 0 }}
                    >
                      <Grid.Row >
                        <Grid.Column>
                          <h4>{t('Format')}</h4>
                        </Grid.Column>
                        <Grid.Column textAlign="right">
                          <Button
                            content={t('Preview', { ns: TRANSLATION_FILES.translation })}
                            disabled={this.state.loading}
                            onClick={this.handlePreview}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    <TextArea
                      validation={[required]}
                      ref={this.validation.addressFormatTemplate}
                      onChange={this.handleInputChange}
                      validateLabel={t('Address format')}
                      autoComplete="off"
                      name="addressFormatTemplate"
                      value={data ? data.addressFormatTemplate : ''}
                      rows={1}
                      style={{ width: '100%', minHeight: '6em', height: '6em' }}
                    />
                    {
                      this.state.previewFormat ? (
                        <Segment>
                          <h4>{t('Preview', { ns: TRANSLATION_FILES.translation })}</h4>
                          <div style={{ whiteSpace: 'break-spaces' }}>
                            {this.state.previewFormat}
                          </div>
                        </Segment>
                      ) : null
                    }
                    <Divider horizontal>{t('Address settings')}</Divider>
                    <Message warning>
                      <Message.Header>
                        {t('Please note').toUpperCase()}
                      </Message.Header>
                      <p>
                        {t('Any changes to the labels will cause misrepresentation of data which have already been keyed in. Please proceed at your own risk.')}
                      </p>
                    </Message>
                    <AddressSettingList
                      ref={(ref) => { this.addressSettingList = ref; }}
                      onOriChange={this.handleAddressSettingOriChange}
                      onChange={this.handleAddressSettingChange}
                      loading={this.state.loading}
                    />
                    <Divider horizontal>{t('Activity Logs')}</Divider>
                    <Segment>
                      <AddressSettingActivities
                        data={this.state.addressSettingActivities || []}
                        hasAccess
                        loading={this.state.loading || this.state.activitiesLoading}
                      />
                      <Divider hidden />
                      <Grid.Row>
                        <Grid.Column style={{ textAlign: 'center' }}>
                          {
                            this.state.addressSettingActivities ?
                              <Button
                                as={Link}
                                to="/settings/address_settings/activities/"
                                content={t('View More', { ns: TRANSLATION_FILES.translation })}
                              />
                            : null
                          }
                        </Grid.Column>
                      </Grid.Row>
                    </Segment>
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('source_of_financing')}>
                    <Divider horizontal>{t('Sources of Financing', { ns: TRANSLATION_FILES.screens })}</Divider>
                    <FinanceSourceList
                      ref={(ref) => { this.financeSourceList = ref; }}
                      onOriChange={this.handleFinanceSourcesOriChange}
                      onChange={this.handleFinanceSourcesChange}
                      loading={this.state.loading}
                      isForeignCompany={isForeignCompany(data.company)}
                    />
                  </Grid.Column>
                  <Grid.Column stretched className={this.checkActiveTab('reservation_token')}>
                    <Dimmer active={this.state.reservationTokenLoading} inverted>
                      <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                    </Dimmer>
                    <Divider horizontal>{t('Reservation Token Settings')}</Divider>
                    <div className="ui form">
                      <Form.Group widths="equal">
                        <Form.Input
                          label={t('Price Minor', { ns: TRANSLATION_FILES.translation })}
                          name="priceMinor"
                          type="number"
                          step="1"
                          value={this.state.reservationTokenSettings.priceMinor}
                          onChange={this.handleReservationTokenInputChange}
                          validation={[required, {
                            validate: numericRange,
                            option: {
                              min: 1,
                            },
                          }]}
                        />
                      </Form.Group>
                      <Form.Group widths="equal">
                        <Form.Input
                          label={t('Validity Duration (Days)')}
                          name="validityDurationDays"
                          type="number"
                          min="0"
                          step="1"
                          value={this.state.reservationTokenSettings.validityDurationDays}
                          onChange={this.handleReservationTokenInputChange}
                        />
                      </Form.Group>
                      <Form.Group widths="equal">
                        <Form.Input
                          label={t('Limit Per Opportunity')}
                          name="limitPerOpportunity"
                          type="number"
                          min="0"
                          step="1"
                          value={this.state.reservationTokenSettings.limitPerOpportunity}
                          onChange={this.handleReservationTokenInputChange}
                        />
                      </Form.Group>
                      <Form.Group widths="equal">
                        <Form.Select
                          label={t('Currency')}
                          name="currencyCode"
                          options={[
                            { key: 'MYR', text: 'MYR', value: 'MYR' },
                            { key: 'IDR', text: 'IDR', value: 'IDR' },
                            { key: 'VND', text: 'VND', value: 'VND' },
                          ]}
                          noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                          value={this.state.reservationTokenSettings.currencyCode}
                          onChange={(e, { name, value }) => this.handleReservationTokenInputChange(e, { name, value })}
                        />
                      </Form.Group>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(SystemSettings.mapStateToProps)(SystemSettings));



// WEBPACK FOOTER //
// ./src/containers/SystemSettings/SystemSettings.jsx